module.exports = __webpack_public_path__ + "img/c13.bf83685d.png";